module.exports = ".route-img img {\n  height: 24px;\n  vertical-align: sub;\n  margin-right: 5px; }\n\nul {\n  margin-top: 5px;\n  margin-bottom: 5px; }\n\n.saved-routes-line {\n  display: block;\n  height: 1px;\n  width: 80%;\n  margin: auto;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  background: #d4d4d4; }\n\n.delete-close {\n  position: absolute;\n  display: inline-block;\n  background: #f0f0f0;\n  width: 22px;\n  height: 22px;\n  line-height: 20px;\n  text-align: center;\n  border-radius: 50%;\n  color: #353535;\n  margin-left: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account/my-favorites/my-favorites.component.scss
// module id = 711
// module chunks = 0